var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddCalendar = function SvgAddCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-14495.146 -17622.596 24.462 20.877",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-4 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #fff;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbol_329_2",
    transform: "translate(-14626 -18159.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_84",
    className: "cls-1",
    transform: "translate(135.977 538.419)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 19.339,
    height: 17.58,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 18.339,
    height: 16.58,
    rx: 1.5
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_582",
    className: "cls-1",
    d: "M4467-22396.477h18.6",
    transform: "translate(-4330.289 22940.51)"
  }))))))))))))))))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_85",
    className: "cls-2",
    transform: "translate(141.251 536.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1,
    height: 4.395,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    height: 3.395
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_86",
    className: "cls-2",
    transform: "translate(149.163 536.66)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 1,
    height: 4.395,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    height: 3.395
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1502",
    transform: "translate(131.355 547.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_685132_cc",
    transform: "translate(13.157 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1802",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1794",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1790",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1778",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1770",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1758",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1754",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1750",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1738",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1730",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1726",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1722",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1718",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1714",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    className: "cls-2",
    d: "M4.685.072.084,4.7a.312.312,0,0,0-.013.411.271.271,0,0,0,.385.014L4.6.959V12.868a.271.271,0,1,0,.541,0V.959l4.145,4.17a.269.269,0,0,0,.385-.014A.309.309,0,0,0,9.659,4.7L5.058.072A.276.276,0,0,0,4.685.072Z"
  })))))))))))))))))))))))))))))))))))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addCalendar.a99b6d31.svg";
export { ForwardRef as ReactComponent };